import * as messageBus from '@wh/message-bus';
import { Store } from '@wh/store';

import './styles/index.scss';

import createStore from './framework/store';
import { start as startLogic } from './framework/logic';
import startPorts from './framework/ports/createPortsFacade';
import createPortsInventory from './framework/ports/createPortsInventory';
import portsMap from './framework/ports/portsMap';

import appRenderer from './renderer';

window.WH = {
  messageBus,
  storages: {
    business: Store.getInstance('business'),
  },
};

const initialPresenterLayout =
  window.initialPresenterLayout &&
  (window.initialPresenterLayout.renderManifest ||
    window.initialPresenterLayout);
const store = createStore(initialPresenterLayout);
startPorts(createPortsInventory(portsMap));
startLogic();
appRenderer(store);
